import styled from "@emotion/styled";
import Form from "global/components/form";

export const FieldGroup = styled(Form.FieldGroup)`
  --FieldGroup-row-gap: 50px;
  --BaseGroup-flex-flow: column nowrap;
`;

export const Button = styled.button`
  margin-block-start: 60px;
`;
